async function addToCartAndOpenDrawer(variantId, quantity = 1) {
  const cartDrawer = document.querySelector("cart-drawer");

  // Build the request
  const formData = new FormData();
  formData.append("id", variantId);
  formData.append("quantity", quantity);

  if (cartDrawer) {
    const sections = cartDrawer.getSectionsToRender().map(s => s.id);
    formData.append("sections", sections);
  }

  formData.append("sections_url", window.location.pathname);

  // Add to cart
  const response = await fetch("/cart/add.js", {
    method: "POST",
    body: formData,
    headers: { "X-Requested-With": "XMLHttpRequest" }
  });

  const data = await response.json();

  if (data.status) {
    // Error (e.g., sold out)
    console.error("Cart error:", data.description);
    return;
  }

  // Success - update and open the drawer
  if (cartDrawer) {
    cartDrawer.renderContents(data, true);
  } else {
    // Fallback: redirect to cart page
    window.location = "/cart";
  }
}